import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './components2/all'
import inViewportDirective from 'vue-in-viewport-directive'
import vClickOutside from 'v-click-outside'
import Meta from 'vue-meta'
import VueDOMPurifyHTML from 'vue-dompurify-html'

Vue.use(Meta)
Vue.directive('in-viewport', inViewportDirective)
Vue.use(vClickOutside)
Vue.use(VueDOMPurifyHTML)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
